var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ open }) {
              return [
                _c(
                  "v-row",
                  { attrs: { "no-gutters": "" } },
                  [
                    _c("span", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v(_vm._s(_vm.title)),
                    ]),
                    _c("v-fade-transition", [
                      open
                        ? _c(
                            "span",
                            { staticStyle: { display: "inline-flex" } },
                            [
                              _c("v-divider", {
                                staticClass: "mx-2",
                                attrs: { vertical: "" },
                              }),
                              _c(
                                "v-btn",
                                {
                                  attrs: { color: "primary", small: "" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.click_add.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("ADD")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c("v-spacer"),
                    _c("v-fade-transition", [
                      open
                        ? _c(
                            "span",
                            { staticStyle: { display: "inline-flex" } },
                            [
                              _c("v-divider", {
                                staticClass: "mx-1",
                                attrs: { vertical: "" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c(
        "v-expansion-panel-content",
        [
          _c("r-product-table", {
            ref: "table",
            attrs: { items: _vm.items, kinds: _vm.kinds, toolbar: false },
            on: {
              "update:items": function ($event) {
                return _vm.$emit("update:items", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }